import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { mapI18nToBackendCode } from './languages'

// Language resources will be loaded dynamically
const resources = {}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: ['sr', 'en'],
    lng: localStorage.getItem('app_language') || 'sr',

    debug: false,

    interpolation: {
      escapeValue: false, // React already escapes
    },

    // Load translations from public/locales/{lng}/translation.json
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },

    detection: {
      // Order of language detection
      order: ['cookie', 'localStorage', 'navigator'],
      caches: ['cookie'],
      cookieMinutes: 10080, // 7 days
      lookupCookie: 'django_language', // Django's language cookie name
      lookupLocalStorage: 'i18nextLng',
    },
  })

// Function to load language dynamically
export const loadLanguage = async (lng: string) => {
  try {
    const response = await fetch(`/locales/${lng}/translation.json`)
    if (!response.ok) {
      return false
    }
    const translations = await response.json()
    i18n.addResourceBundle(lng, 'translation', translations, true, true)
    await i18n.changeLanguage(lng)

    // Use Django's supported language codes for backend validation messages.
    document.cookie = `django_language=${mapI18nToBackendCode(lng)};path=/;max-age=604800` // 7 days

    return true
  } catch (error) {
    return false
  }
}

// Initialize with stored language if available
const persistedLanguage = localStorage.getItem('app_language')
loadLanguage(persistedLanguage || 'sr')

export default i18n
